import React from 'react';
import { Tooltip, IconButton } from '@mui/material';

const BtnAcciones = ({ icon, label, onClick }) => {
    return (
        <Tooltip title={label}>
            <IconButton onClick={onClick}>
                {icon}
            </IconButton>
        </Tooltip>
    );
};

export default BtnAcciones;